import {scrollTo, scrollToRecursion} from "./go-to-anchor";
import {getEventDelay} from "./get-event-delay";
import {throttle} from "./throttle";
import {scrollEventToggle} from "./scroll-event-toggle";

export function tableSection($tableSection) {
  let win = window;
  let $win = $(window);
  let itemsGlobal = [];
  let tableName = 'table';
  let tableSelector = '.' + tableName;
  let tableSectionName = tableName + '-section';
  let tableSectionSelector = '.' + tableSectionName;
  let initializedClassName = tableSectionName + '-initialized';
  let duration = 400;
  let activeClass = 'active';
  let openClass = 'open';
  let openFilterClass = 'open' + '-filter';
  let openBtnSelector = '.toggle-arrow-btn';
  let openMobileFilterName = 'open-mobile-filter';
  let openMobileFilterSelector = '.' + openMobileFilterName;
  let tableDropdownName = 'table-dropdown';
  let tableDropdownSelector = '.' + tableDropdownName;
  let tableDropdownHeadName = 'table-dropdown-head';
  let tableDropdownHeadSector = '.' + tableDropdownHeadName;
  let viewClassPrefix = '-view';
  let desktopViewClass = 'desktop' + viewClassPrefix;
  let mobileViewClass = 'mobile' + viewClassPrefix;
  let positionStickyClass = 'sticky';
  let cellInnerSelector = 'tr:eq(1) th';
  let delta = 20;
  let lasRowClass = 'last';
  let $anchorsMenu = $('.hero-section .anchors-list');
  let desktopBreakpointAttr = 'data-desktop-breakpoint';

  function _setFilter(currentValue, isCategory) {
    let currentFilter = this.filters[isCategory ? 0 : 1];
    let tabsItems = this.tabs.items;

    currentFilter.items.forEach(function (filterItem, index) {
      let currentFilterValueIsEqual = filterItem.value === currentValue;

      filterItem.$item ['' + (currentFilterValueIsEqual ? 'add' : 'remove') + 'Class'](activeClass);
      filterItem.$itemStickyPanel ['' + (currentFilterValueIsEqual ? 'add' : 'remove') + 'Class'](activeClass);

      if (isCategory) {
        let tabItem = tabsItems[index];
        let currentTabValueIsEqual = tabItem.value === currentValue;

        tabItem.$item ['' + (currentTabValueIsEqual ? 'add' : 'remove') + 'Class'](activeClass);
      }
    });

    currentFilter.currentValue = currentValue;
    currentFilter.$dropdown.add(currentFilter.$dropdownStickyPanel).removeClass(openClass);
  }

  function addItems($items) {
    let items = $items || $(tableSectionSelector);

    items.each(function () {
      let $section = $(this);

      if (!$section.hasClass(initializedClassName)) {
        $section.addClass(initializedClassName);
        let _scrollEventToggle = scrollEventToggle();
        let $table = $section.find(tableSelector + '-full');
        let $thead = $table.find('thead');
        let $stickyPanel = $section.find(tableSelector + '-sticky-panel');
        let $stickyPanelTable = $stickyPanel.find('table');

        $stickyPanelTable.append($thead.prop('outerHTML'));

        requestAnimationFrame(function () {
          let $theadCell = $thead.find(cellInnerSelector);
          let $stickyPanelTheadCell = $stickyPanelTable.find(cellInnerSelector);
          let $stickyPanelDropdowns = $stickyPanelTheadCell.find(tableDropdownSelector)
          let cell = [];
          let $openMobileFilterBtns = $section.find(openMobileFilterSelector);
          let tabs = {
            list: $section.find('.steps-list ul'),
            items: []
          };
          let filters = {};
          let rows = [];
          let isSectionParentColumns = Boolean($section.closest('.columns').length);

          if (isSectionParentColumns) {
            $section.attr(desktopBreakpointAttr, 1700);
          }

          let desktopBreakpoint = $section.attr(desktopBreakpointAttr) * 1;

          let _isLargeBreakpoint = function () {
            return win.innerWidth >= desktopBreakpoint;
          }

          $theadCell.each(function (index) {
            let $curTheadCell = $(this);
            let $curStickyPanelTheadCell = $stickyPanelTheadCell.eq(index);

            cell.push(
              {
                $theadCell: $curTheadCell,
                $stickyTheadCell: $curStickyPanelTheadCell
              }
            )
          });

          tabs.list.find('li').each(function () {
            let $item = $(this);

            tabs.items.push(
              {
                $item: $item,
                value: $item.find('a').data('value')
              }
            )
          });

          $theadCell.find(tableDropdownSelector).each(function (index) {
            let $dropdown = $(this);
            let $dropdownStickyPanel = $stickyPanelDropdowns.eq(index);
            let $dropdownHead = $dropdown.find(tableDropdownHeadSector);
            let $dropdownHeadStickyPanel = $dropdownStickyPanel.find(tableDropdownHeadSector);
            let $itemsStickyPanel = $dropdownStickyPanel.find('li');
            let items = [];
            let currentValue = null;

            $dropdown.find('li').each(function (indexDropdownItem) {
              let $dropdownItem = $(this);
              let value = $dropdownItem.data('value');

              if ($dropdownItem.hasClass(activeClass)) {
                currentValue = value;
              }

              items.push({
                $item: $dropdownItem,
                $itemStickyPanel: $itemsStickyPanel.eq(indexDropdownItem),
                value: value
              });
            });

            let dropdownProps = {
              $dropdown: $dropdown,
              $dropdownStickyPanel: $dropdownStickyPanel,
              $dropdownHead: $dropdownHead,
              $dropdownHeadStickyPanel: $dropdownHeadStickyPanel,
              items: items,
              currentValue: currentValue
            };

            filters[index] = dropdownProps;
          });

          $table.find('tbody tr').each(function () {
            let $item = $(this);

            rows.push({
              $item: $item,
              category: $item.data('category'),
              severity: $item.data('severity')
            });
          });

          let instance = {
            $section: $section,
            $stickyPanel: $stickyPanel,
            $table: $table,
            $stickyPanelTable: $stickyPanelTable,
            $openMobileFilterBtns: $openMobileFilterBtns,
            cell: cell,
            tabs: tabs,
            rows: rows,
            filters: filters,
            desktopBreakpoint: desktopBreakpoint,
            isSticky: false,
            isDesktopMode: _isLargeBreakpoint(),
            isOpenMobileFilter: false,
            setSticky: function (isSticky) {
              this.isSticky = isSticky;
              this.$section ['' + (isSticky ? 'add' : 'remove') + 'Class'](positionStickyClass);

              if (isSticky) {
                let $curTable = this.$table;

                this.$stickyPanel.css({
                  left: $curTable.offset().left + 'px',
                  width: $curTable.outerWidth() + 'px'
                });
              } else {
                this.$stickyPanel.removeAttr('style');
              }
            },
            setCellWidth: function () {
              let isDesktopMode = this.isDesktopMode;

              this.cell.forEach(function (item, index) {
                if (isDesktopMode) {
                  item.$stickyTheadCell.css('width', item.$theadCell.outerWidth() + 'px');
                } else {
                  item.$stickyTheadCell.removeAttr('style');
                }
              });
            },
            setViewMode: function () {
              let isLargeBreakpoint = _isLargeBreakpoint();

              ['$section', '$table', '$stickyPanelTable'].map((prop) => {
                this[prop]
                  ['' + (isLargeBreakpoint ? 'remove' : 'add') + 'Class'](mobileViewClass)
                  ['' + (isLargeBreakpoint ? 'add' : 'remove') + 'Class'](desktopViewClass);
              });
              this.isDesktopMode = isLargeBreakpoint;
              this.setCellWidth();

              if (isLargeBreakpoint) {
                _scrollEventToggle.enable();
              }
            },
            setCategory: function (currentValue) {
              _setFilter.call(this, currentValue, true);
            },
            setSeverity: function (currentValue) {
              _setFilter.call(this, currentValue);
            },
            toggleMobileFilter: function (isShow) {
              this.$table.add(this.$stickyPanelTable)['' + (isShow ? 'add' : 'remove') + 'Class'](openFilterClass);
              this.isOpenMobileFilter = isShow;

              if (isShow) {
                scrollTo(this.$stickyPanel.offset().top);
              }

              _scrollEventToggle[isShow ? 'disable' : 'enable'](true);
            },
            filterItems: function () {
              let currentValueCategory = this.filters[0].currentValue;
              let currentValueSeverity = this.filters[1].currentValue;
              let lastRowIndex = 0;
              let visibleCounter = 0;

              this.rows.forEach(function (item, index) {
                //let isShowCategory = item.category === currentValueCategory;
                let category = item.category.toString();
                let isShowCategory = false;
                let nameActiveCategory = document.querySelector(".steps-list li.active").textContent;
                
                if( category.lastIndexOf( currentValueCategory.toString() ) !== -1 ){
                  isShowCategory = true;
                }

                let isShowSeverity = (currentValueSeverity === 'all') || (item.severity === currentValueSeverity);
                let isVisible = isShowCategory && isShowSeverity

                item.$item.removeClass(lasRowClass);
                item.$item['' + (isVisible ? 'remove' : 'add') + 'Class']('hidden');

                if (isVisible) {
                  lastRowIndex = index;
                  visibleCounter++;
                  item.$item.find('td:first-of-type').text(nameActiveCategory);
                }
              });

              //console.log('len = ' + this.rows.length);
              //console.log('visibleCounter = ' + visibleCounter);

              this.rows[lastRowIndex].$item.addClass(lasRowClass);
              this.setCellWidth();
              this.toggleMobileFilter(false);
              this.$table[(visibleCounter > 0 ? 'remove' : 'add') + 'Class']('no-results');


              if (this.isSticky) {
                scrollTo(this.$table.offset().top, null, 0);
              }
            }
          };

          itemsGlobal.push(instance);

          //filter
          instance.filterItems();

          //click on 'open mobile filter'
          $openMobileFilterBtns.click(function () {
            instance.toggleMobileFilter(!instance.isOpenMobileFilter);
          });

          //click on 'mobile item toggle/ thead filter dropdown/ thead filter dropdown item'
          $section.on('click', openBtnSelector + ', ' + tableDropdownHeadSector + ', ' + tableDropdownSelector + ' li', function (e) {
            e.preventDefault();

            let btn = $(this);
            let isTableDropdownHead = btn.hasClass(tableDropdownHeadName);
            let isFilterItem = btn.is('li');

            if (isTableDropdownHead) {
              btn.closest(tableDropdownSelector).toggleClass(openClass);

            } else if (isFilterItem) {
              //click on filter items
              let filters = instance.filters;
              let curDropdown = btn.closest(tableDropdownSelector);
              let curValue = btn.data('value');
              let isCategoryDropdown = curDropdown.is(filters[0].$dropdown) || curDropdown.is(filters[0].$dropdownStickyPanel);

              instance[isCategoryDropdown ? 'setCategory' : "setSeverity"](curValue);
              instance.filterItems();
            } else {
              //click on 'mobile item toggle'
              let currentCell = btn.closest('td');
              let currentCellIndex = currentCell.index();
              let item = currentCell.closest('tr').toggleClass(activeClass);
              let hidden = item.find('td:gt(' + currentCellIndex + ')');
              let isActive = !btn.hasClass(activeClass);

              if (isActive) {
                let otherItems = item.siblings().removeClass(activeClass);
                otherItems.find('td:gt(' + currentCellIndex + ')').slideUp(0);
                otherItems.find(openBtnSelector).removeClass(activeClass);
              }

              btn.toggleClass(activeClass);
              hidden.slideToggle(duration, function () {
                if (e.originalEvent !== undefined) {
                  scrollTo(item.offset().top - $stickyPanel.outerHeight(), null, 220);
                }
              });
            }
          });

          //click on tabs end top anchors list
          tabs.list.add($anchorsMenu).on('click', 'a', function (e) {
            e.preventDefault();
            instance.setCategory($(this).data('value'));
            instance.filterItems();
          });
        });
      }
    });
  }

  function resize() {
    if (itemsGlobal.length) {
      itemsGlobal.forEach(function (item) {
        item.setViewMode();
      });
    }
  }

  function toggleSticky() {
    if (itemsGlobal.length) {
      $.each(itemsGlobal, function (index, item) {
        let $curTable = item.$table;
        let curTableHeight = parseInt($curTable.outerHeight());
        let $targetBlock = item.$stickyPanel;
        let targetBlockHeight = parseInt($targetBlock.outerHeight());

        if ((targetBlockHeight + delta) < curTableHeight) {
          let offsetTop = $curTable.offset().top;
          let winScrollTop = $win.scrollTop();
          //let headerHeight = stickyWrappersItem.header.offsetHeight;
          let headerHeight = 0;
          let bottomPosition = offsetTop + curTableHeight - headerHeight - targetBlockHeight;
          let isScrollOutsideTheBottomPosition = bottomPosition < winScrollTop;
          let isRemoveStickyClass = isScrollOutsideTheBottomPosition || (offsetTop > (winScrollTop + headerHeight));

          if (isRemoveStickyClass) {
            item.setSticky(false);
          } else {
            item.setSticky(true);
          }
        } else {
          item.setSticky(false);
        }
      });
    }
  }

  $win.on("load", function () {
    addItems();

    requestAnimationFrame(function () {
      toggleSticky();
      resize();
      toggleSticky();
    });

    ["resize", "orientationchange"].map(function (item) {
      let eventDelay = getEventDelay(item);
      $win.on(item, throttle(resize, eventDelay));
    });

    $win.on('scroll', toggleSticky);
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/table-section.js